import { EmeraldError } from 'src/common/api/emerald-error';
import { TenderType } from 'src/common/enumerations/tender-type';
import { store } from 'src/common/redux/configure-store';
import { EpsData } from 'src/devices/payment/dtos/eps-data';
import { getCardData } from 'src/devices/payment/get-card-details';

export const getEPSData = (tenderId?: string): EpsData => {
  const callGetCardDetailsByTenderType = store.getState().touchPoint.touchPointConfiguration
    .callGetCardDetailsByTenderType;
  if (!callGetCardDetailsByTenderType) {
    return getCardData();
  } else {
    const rawTenders = store.getState().tenderMenu.sellableTenders.rawTenders;
    const tender =
      rawTenders.find(f => f.id === tenderId) ??
      rawTenders.find(f => f.type === TenderType.CreditDebit);
    if (!tender) {
      throw new EmeraldError('No_Tenders', 'EFT Tender unavailable');
    }

    return {
      sessionTranID: '',
      paymentTranID: '',
      card: {
        cardCode: tender.tenderReferences?.slice(-1)[0],
        cardName: tender.description,
      },
    };
  }
};
